import React, { CSSProperties, useEffect } from 'react';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import { useModalContext } from '../../Modules/Modal/Services/ModalContext';

interface Props {
	children?: React.ReactNode;
	formMethods: UseFormReturn<any>;
	style?: CSSProperties | undefined;
	registerForChanges?: boolean;
	className?: string;
}

const FormWrapper = ({
	children,
	formMethods,
	style,
	registerForChanges = true,
	className,
}: Props) => {
	const modalContext = useModalContext();

	useEffect(() => {
		if (registerForChanges) {
			setTimeout(() => {
				modalContext?.registerForm(() => formMethods);
			}, 500);
		}
		return () => {
			setTimeout(() => {
				if (registerForChanges) {
					modalContext?.unregisterForm(() => formMethods);
				}
			}, 500);
		};
	}, []);

	return (
		<FormProvider {...formMethods}>
			<form action='' style={style} className={className}>
				{children}
			</form>
		</FormProvider>
	);
};

export default FormWrapper;
